// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ewi2","team":"styles_team__hBkyr"};